import React, { useState, useEffect } from "react";
import { findIndex } from "lodash";
import { Modal } from "react-bootstrap";
import Swiper from "react-id-swiper";
import { CHARM_TYPE, URL_IMG, MAX_WIDTH_SP } from "../../const";

function ModalSelectSize(props) {
  const [swiper, updateSwiper] = useState(null);
  const [isBeginning, setBeginning] = useState(true);
  const [isEnd, setEnd] = useState(false);
  const [isCenterMode, setCenterMode] = useState(false);
  const [sizes, setSizes] = useState([]);

  useEffect(() => {
    handleCheckSize();
  });

  let {
    isShowModalSelectSize,
    dataStoneItem,
    handleUpdateState,
    getWidthBrowser
  } = props;
  let sizeDefault = 8;
  let params = {
    loadMinimal: true,
    loadMinimalSize: 0,
    slidesPerView: 3,
    spaceBetween: 10,
    loop: false,
    onlyExternal: true,
    noSwiping: getWidthBrowser() >= MAX_WIDTH_SP
  };

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
      setBeginning(swiper.isBeginning);
      setEnd(swiper.isEnd);
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
      setBeginning(swiper.isBeginning);
      setEnd(swiper.isEnd);
    }
  };

  const handleChoice = (item, sizes) => {
    let itemStorage = {
      id: item.id,
      name: item.name,
      image: item.image_design,
      fortunes: item.fortunes,
      sizes: sizes,
      type: item.type
    };
    let objSize = getMetaImg(`${URL_IMG}${item.image_design}`);
    let materials = JSON.parse(localStorage.getItem("materials")) || [];

    itemStorage.objSize = objSize;
    materials.push(itemStorage);
    localStorage.setItem("materials", JSON.stringify(materials));

    handleCheckSize();
    handleUpdateState("isUpdateMaterialsTray", true);
    handleUpdateState("isShowModalConfirmSelectNewStone", true);
  };

  const handleCheckSize = () => {
    let materials = JSON.parse(localStorage.getItem("materials")) || [];
    sizes.map(item => {
      if (dataStoneItem.type === CHARM_TYPE) {
        item.height = (item.size + 10) * 3;
      } else {
        item.height =
          (item.size > 12 ? 12 + (item.size * 3) / 100 : item.size) *
          sizeDefault;
      }

      let indexItem = findIndex(
        materials,
        material =>
          material.sizes.id === item.id && material.sizes.size === item.size
      );

      if (indexItem !== -1) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });
  };

  const getMetaImg = url => {
    let img = new Image(url);

    img.src = url;

    return {
      height: img.naturalHeight,
      width: img.naturalWidth
    };
  };

  if (sizes.length === 0) {
    let cloneObj = Object.assign([], dataStoneItem.sizes);
    setSizes(cloneObj);

    if (dataStoneItem.sizes.length <= 3) {
      setBeginning(true);
      setEnd(true);
      setCenterMode(true);
    }
  }

  return (
    <Modal
      show={isShowModalSelectSize}
      onHide={() => handleUpdateState("isShowModalSelectSize", false)}
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal_select_size modal_custom modal_select_size_custom"
      centered
    >
      <Modal.Body>
        <button
          className="modal_close"
          onClick={() => handleUpdateState("isShowModalSelectSize", false)}
        >
          <img src="/img/icon_close_new.png" alt="" />
        </button>
        <div className="wrap-image">
          <div
            className={`image-large ${
              dataStoneItem.type === CHARM_TYPE ? " image-charm" : ""
            }`}
          >
            <img src={`${URL_IMG}${dataStoneItem.image_design}`} alt="" />
          </div>
          <div className="desc-detail desc-detail_new">
            <span className="desc-detail_name">{dataStoneItem.name}</span><br/>
            <span className="desc-detail_detail">{dataStoneItem.detail}</span>
          </div>
        </div>

        <div className="wrap-image-slide wrap-image-slide-new">
          <div className={`image-focus ${isCenterMode ? "center-mode" : ""}`}>
            <Swiper {...params} getSwiper={updateSwiper}>
              {sizes.map((size, i) => {
                return (
                  <div
                    key={i}
                    className={`image-item ${
                      size.selected ? "selected-item" : ""
                    }`}
                  >
                    <div
                      className={`image ${
                        dataStoneItem.type === CHARM_TYPE ? "image-charm" : ""
                      }`}
                    >
                      <img
                        src={`${URL_IMG}${dataStoneItem.image_design}`}
                        alt=""
                        style={{
                          height:
                            getWidthBrowser() < MAX_WIDTH_SP
                              ? size.height / 2.2
                              : size.height / 0.94
                        }}
                      />
                    </div>
                    <div className="decs">
                      <div className="size no-p-b">
                        <span>{size.size + "mm"}</span>
                      </div>
                      <div className="price">
                        <span>{size.price + "円"}</span>
                      </div>
                      <button
                        className={`${size.selected ? "selected-button" : ""}`}
                        onClick={
                          size.selected
                            ? () => {}
                            : () => handleChoice(dataStoneItem, size)
                        }
                      >
                        {size.selected ? "選択済み" : "選択"}
                      </button>
                    </div>
                  </div>
                );
              })}
            </Swiper>
            <div
              className={`swiper-button swiper-button-prev ${
                isBeginning ? "swiper-button-disabled" : ""
              }`}
              onClick={goPrev}
            />
            <div
              className={`swiper-button swiper-button-next ${
                isEnd ? "swiper-button-disabled" : ""
              }`}
              onClick={goNext}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalSelectSize;
